<div class="content-inner content-inner-nav" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <div class="title-bar title-bar-nav">
        <div class="container-fluid">
            <div class="row">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-auto">
                        <h2 class="page-title">
                            {{'webKess' | translate}}
                        </h2>
                    </div>
                    <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                        <div class="col-auto institution-name pl-0">
                            <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <nav class="nav nav-pills nav-title d-none d-md-flex">
            <!-- <a *ngIf="(config.userData) && (config.userData.roleName.roleId == 1)" class="nav-link"
                routerLink="/chc/configure" routerLinkActive='active'>{{'Configure' | translate}}</a> -->
            <a *ngIf="(config.userData) && (config.userData.roleName.roleId !== 5)" class="nav-link" routerLink="/chc/reports" routerLinkActive='active'>{{'WEBKESS_INTEGRATION.REPORTS_1' | translate}}</a>
        </nav>
        <div class="d-block d-md-none">
            <div class="btn-group btn-block customDropdown" dropdown>
                <button id="button-basic" dropdownToggle type="button" class="btn btn-muted btn-block dropdown-toggle" aria-controls="dropdown-basic">
                        <!-- {{ButtonDropdown}} -->
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu btn-block customDropdownList" role="menu" aria-labelledby="button-basic">
                    <!-- <li role="menuitem"><a class="dropdown-item" href="#">Action</a></li> -->
                    <!-- <li role="menuitem active"><a *ngIf="(config.userData) && (config.userData.roleName.roleId == 1)" class="nav-link"
                        routerLink="/chc/configure" routerLinkActive='active'>{{'Configure' | translate}}</a></li> -->
                    <li role="menuitem"><a *ngIf="(config.userData) && (config.userData.roleName.roleId !== 5)" class="nav-link" routerLink="/chc/reports" routerLinkActive='active'>{{'WEBKESS_INTEGRATION.REPORTS_1' | translate}}</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>
</div>